module.exports = __webpack_public_path__ + "static/icare-00-hero-f115bc765b9e3a11098453d367e607c4.jpg";